import type { AssetCatalogEntry } from '@buxus/shared'
import { catalogProductLabel } from './assetCatalogDisplay'

type AssetIndexListProps = {
  entries: readonly AssetCatalogEntry[]
  onSelect: (assetId: string) => void
}

/** Full scrollable asset index (mobile AssetSearchResults parity). */
export function AssetIndexList({ entries, onSelect }: AssetIndexListProps) {
  if (!entries.length) {
    return <p className="all-assets-index-empty">No assets available for this operator.</p>
  }

  return (
    <nav className="all-assets-index" aria-label={`All Assets (${entries.length})`}>
      <ul className="all-assets-index-list">
        {entries.map((entry) => {
          const subtitle = catalogProductLabel(entry)
          return (
            <li key={entry.id}>
              <button type="button" className="all-assets-index-row" onClick={() => onSelect(entry.id)}>
                <span className="all-assets-index-row-main">
                  <span className="all-assets-index-row-title">{entry.displayName}</span>
                  {subtitle ? (
                    <span className="all-assets-index-row-subtitle">{subtitle}</span>
                  ) : null}
                </span>
                <span className="all-assets-index-row-chevron" aria-hidden>
                  →
                </span>
              </button>
            </li>
          )
        })}
      </ul>
    </nav>
  )
}
